import { render } from "./InputNumber.vue?vue&type=template&id=4c522538&ts=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputNumber.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/InputNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c522538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c522538', __exports__)) {
    console.log('reload')
    api.reload('4c522538', __exports__)
  }
  
  module.hot.accept("./InputNumber.vue?vue&type=template&id=4c522538&ts=true", () => {
    console.log('re-render')
    api.rerender('4c522538', render)
  })

}


export default __exports__